import { message } from "antd";
import "./CustomNotification.scss";
import SuccessIcon from "../../assets/Icons/SuccessIcon.svg";
import GreenCrossIcon from "../../assets/Icons/GreenCrossIcon.svg";
import ErrorIcon from "../../assets/Icons/ErrorIcon.svg";
import RedCrossIcon from "../../assets/Icons/RedCrossIcon.svg";

const CustomNotification = ({ type, message: customMessage, onClose }) => {
  let isSuccess;
  if (typeof type === "number") {
    isSuccess = type < 399;
  } else {
    isSuccess = type === "success";
  }

  return (
    <div className="custom-message-content">
      <div className="main-content">
        <div className="inner-content">
          <div className={isSuccess ? "Success-image" : "Error-image"}>
            <img
              src={isSuccess ? SuccessIcon : ErrorIcon}
              alt={type}
              style={{ width: 24, height: 24, borderRadius: "50%" }}
            />
          </div>
          <div className="main-headline">
            <div className="headline">
              <strong>{isSuccess ? "Success" : "Error"}</strong>
            </div>
            <div className="sub-headline">
              {customMessage?.replace(/_/g, " ") ||
                (isSuccess
                  ? "Changes saved successfully!"
                  : "Something went wrong. Try again!")}
            </div>
          </div>
        </div>
        <img
          src={isSuccess ? GreenCrossIcon : RedCrossIcon}
          alt="Close"
          onClick={() => {
            message.destroy(); // closes all
            if (onClose) onClose();
          }}
          style={{
            marginLeft: "auto",
            cursor: "pointer",
            width: 20,
            height: 20,
          }}
        />
      </div>
    </div>
  );
};

// ⬇️ Static method to show notification
CustomNotification.show = (msg, type = "success") => {
  message.open({
    duration: 4,
    type,
    placement: "bottomRight",
    icon: null,
    content: (
      <CustomNotification
        type={type}
        message={msg}
        onClose={() => message.destroy()}
      />
    ),
  });
};

export default CustomNotification;
